import useStateHandler from '@/hooks/useStateHandler';

import './styles/EmptyChannel.css';

export default function EmptyChannel({ channelData }) {
  const { state } = useStateHandler();
  const sessionUsername = state.user_session?.user_username;
  const ownerUsername = channelData?.owner_username || channelData?.user_username;
  const isOwner = Boolean(
    channelData?.isOwner
    || (
      sessionUsername
      && ownerUsername
      && String(sessionUsername).toLowerCase() === String(ownerUsername).toLowerCase()
    )
  );

  return (
    <div className="empty-channel-wrapper">
      { isOwner ? (
        <p className="empty-channel__owner-text mt-s">
          Write your first message and inaugurate this channel
        </p>
      ) : (
        <div className="empty-channel__viewer-container">
          <span className="empty-channel__owner-name mt-l">
            {channelData.user_name}
          </span>
          <p className="empty-channel__viewer-text mt-s">
            This gallery hasn't started a conversation yet. Be the first to say hello!
          </p>
        </div>
      )}
    </div>
  );
}
